import { makeStyles, tokens } from '@fluentui/react-components';

export const useDateTimePickerStyles = makeStyles({
  dateTimeRow: {
    display: 'flex',
    gap: tokens.spacingHorizontalS,
    alignItems: 'stretch',
  },
  timePicker: {
    minWidth: '120px',
  },
});
